import React from 'react';
import theme from './NationPrimeTimeGridLoader.module.scss';

const Item = () => (
  <div className={theme.item}>
    <div className={theme.image} />
    <div className={theme.rows}>
      <div className={theme.row} />
      <div className={theme.row} />
    </div>
  </div>
);

const NationPrimeTimeGridLoader = () => (
  <div className={theme.container}>
    <h2 className={theme.sectionHeader}>Live Now</h2>
    <Item />
    <h2 className={theme.sectionHeader}>Today&#39;s Schedule</h2>
    <Item />
    <Item />
    <Item />
    <Item />
  </div>
);

export default NationPrimeTimeGridLoader;
